import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-active-report',
  templateUrl: './active-report.component.html',
  styleUrls: ['./active-report.component.scss']
})
export class ActiveReportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
